import get from 'transmute/get';
export const getCurrentAnimation = get('currentAnimation');